<template>
    <div class="breadcrumb-content">
        <el-breadcrumb :separator-icon="ArrowRight" class="breadcrumb">
            <el-breadcrumb-item :to="{ path: '/' }">{{ $t('index.navBar.home') }}</el-breadcrumb-item>
            <el-breadcrumb-item v-for="(item,index) in props.breadList" :key="index" :to="item.to">{{ $t(item.text) }}</el-breadcrumb-item>
        </el-breadcrumb>
    </div>
</template>

<script lang="ts" setup>
import { BreadType } from '@/typeDefine/EntityType';
import { ArrowRight } from '@element-plus/icons-vue'

const props = defineProps<{
    breadList: BreadType[]
}>()

</script>

<style lang="css" scoped>

.breadcrumb-content .breadcrumb {
    margin: 30px 0;
    padding: 30px 0;
    font-size: 16px;
}
</style>